export default __webpack_public_path__ + "static/media/tooltip_icon_medium.49de8415.svg";